module.exports = __webpack_public_path__ + "img/qa_gp.ecf0c349.svg";